import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Pick up ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_CustomControl = _resolveComponent("CustomControl")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_Marker = _resolveComponent("Marker")!
  const _component_MapUserMarker = _resolveComponent("MapUserMarker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_GemMapPopup = _resolveComponent("GemMapPopup")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_GoogleMap, {
      ref: "mapRef",
      class: "google-map",
      "api-key": _ctx.apiKey,
      center: _ctx.currPosition,
      "clickable-icons": _ctx.mapConfig.clickableIcons,
      "fullscreen-control": _ctx.mapConfig.fullscreenControl,
      "map-type-control-options": _ctx.mapConfig.mapTypeControlOptions,
      "max-zoom": _ctx.mapConfig.maxZoom,
      "min-zoom": _ctx.mapConfig.minZoom,
      "street-view-control": _ctx.mapConfig.streetViewControl,
      styles: _ctx.mapConfig.styles,
      zoom: _ctx.mapConfig.zoom,
      "zoom-control": _ctx.mapConfig.zoomControl
    }, {
      default: _withCtx(() => [
        (Boolean(_ctx.mapRef) && _ctx.mapRef?.ready)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_CustomControl, {
                class: "right-top-controls",
                position: "RIGHT_TOP"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_icon, {
                        class: "circle-button-icon-md filter-to-primary-color",
                        name: require('@/assets/icons/compass.svg'),
                        onClick: _ctx.centerMapOnCurrentLocation
                      }, null, 8, ["name", "onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_icon, {
                        class: "circle-button-icon-md filter-to-primary-color",
                        name: require('@/assets/icons/info.svg'),
                        onClick: _ctx.togglePopup
                      }, null, 8, ["name", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CustomControl, {
                class: "bottom-controls",
                position: "BOTTOM_CENTER"
              }, {
                default: _withCtx(() => [
                  (_ctx.shouldShowPickupGemButton)
                    ? (_openBlock(), _createBlock(_component_van_row, {
                        key: 0,
                        justify: "end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_button, {
                            class: "pick-up-button",
                            round: "",
                            plain: "",
                            type: "primary",
                            "icon-prefix": "pick-up-button-icon",
                            icon: require('@/assets/icons/chevron-right-circle.svg'),
                            "icon-position": "right",
                            onClick: _ctx.pickUpGem
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["icon", "onClick"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_row, {
                    justify: "space-around",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.gems.length > 0)
                        ? (_openBlock(), _createBlock(_component_van_col, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_icon, {
                                class: "circle-button-icon-md prev-gem filter-to-primary-color",
                                name: require('@/assets/icons/chevron-left-circle.svg'),
                                color: "@primary-color",
                                onClick: _cache[0] || (_cache[0] = () => _ctx.prevGem())
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_van_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_icon, {
                            class: "circle-button-icon-lg",
                            name: require('@/assets/images/drop-gem-button.png'),
                            onClick: _ctx.goToDropGem,
                            size: "100"
                          }, null, 8, ["name", "onClick"])
                        ]),
                        _: 1
                      }),
                      (_ctx.gems.length > 0)
                        ? (_openBlock(), _createBlock(_component_van_col, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_icon, {
                                class: "circle-button-icon-md next-gem filter-to-primary-color",
                                name: require('@/assets/icons/chevron-right-circle.svg'),
                                onClick: _cache[1] || (_cache[1] = () => _ctx.nextGem())
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gemMarkerOptions, (markerOptions) => {
                return (_openBlock(), _createBlock(_component_Marker, {
                  ref: _ctx.setGemMarkerRef,
                  onClick: ($event: any) => (_ctx.onGemMarkerClick(markerOptions)),
                  key: markerOptions.id,
                  options: markerOptions
                }, null, 8, ["onClick", "options"]))
              }), 128)),
              _createVNode(_component_MapUserMarker, {
                position: _ctx.currPosition,
                "circle-radius": _ctx.userCircleRadius
              }, null, 8, ["position", "circle-radius"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["api-key", "center", "clickable-icons", "fullscreen-control", "map-type-control-options", "max-zoom", "min-zoom", "street-view-control", "styles", "zoom", "zoom-control"]),
    _withDirectives(_createVNode(_component_GemMapPopup, {
      class: "map-popup",
      "number-gems-pending-collection": _ctx.gems.length,
      "nearest-gem-distance": _ctx.nearestGemDistance,
      "should-show-tutorial": _ctx.shouldShowTutorial
    }, null, 8, ["number-gems-pending-collection", "nearest-gem-distance", "should-show-tutorial"]), [
      [_vShow, _ctx.shouldShowPopup],
      [_directive_click_away, _ctx.hidePopup]
    ])
  ], 64))
}